import { createFileRoute } from '@tanstack/react-router'
import { CandidatePoolDetail } from '@/features/candidate-pool/components/pool-detail'

export const Route = createFileRoute('/_authenticated/candidate-pools/$collectionId')({
  component: CandidatePoolDetail,
})
